// components/Companies.js
/**
 * Companies component
 *
 * This component renders the CompanyList component, which displays a list of companies.
 */
import React from 'react';
import CompanyList from '../../../../examples/Lists/CompanyList';
function Companies() {
  return <CompanyList />;
}
export default Companies;
